/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const ExportDataFormat = {
    Standard: 'standard',
    AllActivity: 'all_activity'
} as const;

export type ExportDataFormat = typeof ExportDataFormat[keyof typeof ExportDataFormat];



